// Core
import { useState, useEffect } from 'react';
import { MdInfoOutline } from "react-icons/md";
import { FaOilCan } from "react-icons/fa";
import { FaLock } from "react-icons/fa";
import { MdToken } from 'react-icons/md';
import { FaSitemap } from "react-icons/fa";

// Chakra 
import { 
  Box,
  Button,
  Divider,
  Image,
  Flex, 
  Grid,
  FormControl,
  FormLabel,
  FormHelperText,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Spinner,
  Text, 
  useColorModeValue,
  useDisclosure
} from '@chakra-ui/react';
import roadSh from '../../assets/road-sh.png';

const AttentionSaleModal = ({ 
  isOpen, onOpen, onClose, 
}) => {

  const handleReset = () => {
    localStorage.clear();

    window.location.reload();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent className="modal__simple modal__attention" maxW={{ sm: '400px' }}>
        <ModalBody>

        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            h="100vh"
          >
            <Box m="0 30px"
              border="1px solid #2d2d2d"
              padding="20px 20px"
              borderRadius="10px"
              bg={`url(${roadSh}) #131313 no-repeat`}
              backgroundSize="cover">

              <Text variant="title-lg" lineHeight="26px" fontSize="22px">
                Are you sure you want to reset your progress?
              </Text>

              <Text mt="16px" variant="text-lg"fontSize="18px">
                All your tokens, cars, colors, and upgrades will be permanently erased. This action cannot be undone.
              </Text>

              <Text mt="8px" variant="text-lg" fontSize="18px">
                 Make sure you're ready for a fresh start before proceeding!
              </Text>

              <Button
                color="black"
                bg="#e7d818" 
                mt="24px" variant="secondary-lg" w="100%" fontSize="18px"
                onClick={handleReset}
                >Confirm</Button>

              <Button mt="16px" variant="secondary-lg" 
                bg="transparent"
                color="#e7d818"
                padding="12px 30px" border="2px solid #e7d818"
                w="100%" fontSize="18px" onClick={onClose}>Cancel</Button>
                
            </Box>
        </Box>
          
        </ModalBody>
      </ModalContent>
    </Modal> 
  );
};

export default AttentionSaleModal;